import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static values = {
    href: String,
    turboFrame: String
  }

  declare hrefValue: string
  declare readonly hasHrefValue: boolean
  declare turboFrameValue: string
  declare readonly hasTurboFrameValue: boolean

  visit (e: any): void {
    const { target } = e

    // Skip if clicking inside a nested <a> with href containing /findings
    const anchor = (target as HTMLElement).closest('a[href*="findings"]')
    if (anchor != null) return
    if (!this.hasHrefValue || target.dataset.clickableRowDisabled === 'true') {
      return
    }

    e.preventDefault()

    Turbo.visit(this.hrefValue, {
      frame: this.hasTurboFrameValue ? this.turboFrameValue : undefined
    })
  }
}
